import type { Role } from '../types';
import { apiClient } from './apiClient';

export interface User {
  id: string;
  email: string;
  name?: string;
  role: Role; // 'admin' | 'viewer'
  avatarUrl?: string;
}

export const AuthService = {
  async getCurrentUser(): Promise<User | null> {
    try {
      // Use detailed profile endpoint
      const me = await apiClient.get<User>(`/users/me`);
      return me ?? null;
    } catch {
      // Fallback to session-only info
      try {
        const data = await apiClient.get<{ user: User }>(`/auth/me`);
        return data.user ?? null;
      } catch {
        return null;
      }
    }
  },

  async login(email: string, password: string): Promise<User> {
    const data = await apiClient.post<{ user: User }>(`/auth/login`, { email, password });
    // After login, fetch enriched profile (avatar/name)
    try {
      const me = await apiClient.get<User>(`/users/me`);
      return { ...data.user, ...me } as User;
    } catch {
      return data.user;
    }
  },

  async logout(): Promise<void> {
    await apiClient.post(`/auth/logout`);
  },
};

export type { Role };
